<div class="entry-field" [ngClass]="{ 'entry-field--error': isError, 'entry-field--outline': outline }">
  <div class="input-label-container">
    <input
      [type]="inputType ? inputType : 'text'"
      class="entry-field__input"
      [ngClass]="{ 'entry-field--outline__input': outline }"
      id="{{ componentId }}"
      name="{{ componentId }}"
      [placeholder]="noLabel ? placeholder : '&nbsp;'"
      [(ngModel)]="val"
      (change)="trigger()"
      (blur)="onblur()"
      [maxlength]="maxlength"
      [disabled]="isState || isDisabled || disableConditionally"
      [textMask]="inputMask ? inputMask : defaultMask"
      pattern="pattern ? pattern : '*'"
    />
    <label
      *ngIf="!noLabel"
      class="entry-field__label"
      for="{{ componentId }}"
      [class.entry-field--error__label]="isError"
      [class.entry-field--filled__label]="!errorMessage[prop] && !!val"
    >
      {{ placeholder }}
    </label>
  </div>
  <ng-content select="[suffix]"></ng-content>
  <p class="error-message error-message--entry-field" *ngIf="isError">{{ errorMessage[prop] }}</p>
</div>
